<template>
  <div class="bg-0D1225 py-4 p-3">
    <div style="width:85%;margin:0 auto">
      <span class="custom-grey-badge mt-5 text-center">ACARA</span>

      <h4 class="custom-54px-600 text-white mt-3 mb-5">
        Alami perjalanan pembelajaran kami, temui bagaimana program kami memberi
        inspirasi, menghubungkan, dan memberdayakan profesional masa depan di
        seluruh Malaysia.
      </h4>
        <div class="gallery-wrapper d-flex overflow-hidden rounded-custom">
          <div
            v-for="(event, index) in events"
            :key="index"
            class="gallery-item"
            :class="{ active: index === activeIndex }"
            @click="activeIndex = index"
          >
            <img :src="event.icon" class="w-100 h-100 object-cover" />

            <div
              v-if="index === activeIndex"
              class="position-absolute d-flex align-items-center"
              style="top: 10px; left: 10px; gap: 8px;"
            >
              <span
                v-for="(tag, i) in event.tags"
                :key="i"
                class="badge badge-light text-dark px-3 py-2 rounded-pill shadow-sm"
                style="font-weight: 500;"
              >
                {{ tag }}
              </span>
              <div
                class="rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm"
                style="width: 60px; height: 60px;"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="black"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42L17.59 5H14V3z"
                  />
                </svg>
              </div>
            </div>

            <!-- Caption -->
            <div
              v-if="index === activeIndex"
              class="position-absolute text-white p-2"
              style="bottom: 10px; left: 10px; background: rgba(0,0,0,0.5); border-radius: 12px;"
            >
              {{ event.caption }}
            </div>
          </div>
        </div>

        <div class="text-center mt-4">
          <CButton type="button" class="custom-white-badge custom-16px-600"
            >See More</CButton
          >
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandableGallery",
  data() {
    return {
      activeIndex: 0,
      events: [
        {
          icon: require("@/assets/img/flyhigh/t3.png"),
          caption: "3 MEI, KUCHING SARAWAK",
          tags: ["Pertumbuhan Pendapatan", "E-Dagang"],
        },
        {
          icon: require("@/assets/img/flyhigh/c4.png"),
          caption: "4 MEI, KUALA LUMPUR",
          tags: ["Inovasi Edukasi", "AI"],
        },
        {
          icon: require("@/assets/img/flyhigh/event2.png"),
          caption: "6 MEI, PENANG",
          tags: ["Startup", "Kreativitas"],
        },
        {
          icon: require("@/assets/img/flyhigh/event3.png"),
          caption: "7 MEI, SELANGOR",
          tags: ["Teknologi Hijau"],
        },
      
      ],
    };
  },
};
</script>

<style scoped>
.gallery-wrapper {
  height: 400px;
  border-radius: 40px;
}

.gallery-item {
  flex: 1;
  overflow: hidden;
  transition: all 0.5s ease;
  position: relative;
  cursor: pointer;
}

.gallery-item.active {
  flex: 3;
}

.gallery-item img {
  height: 100%;
  object-fit: cover;
}
</style>
